module.exports = __webpack_public_path__ + "static/media/reagent.3edd4aa9.png";